import { useNavigate, useLocation } from "react-router-dom";
import { Mic, Square, Loader2, ExternalLink, AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";
import { useRecording, mmss } from "../lib/recording";

const RecordingWidget = () => {
  const { session, elapsed, overdue, transcribing, stop } = useRecording();
  const navigate = useNavigate();
  const location = useLocation();
  if (!session && !transcribing) return null;
  const target = session ? `/therapist/patients/${session.patientId}?session=${session.reportId}` : null;
  const onSessionPage = target && location.pathname + location.search === target;
  return (
    <div className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-2 rounded-full text-white shadow-xl px-4 py-2 text-sm ${overdue ? "bg-amber-600 ring-4 ring-amber-300/60 animate-pulse" : "bg-rose-600"}`} data-testid="recording-widget" data-overdue={overdue ? "1" : "0"}>
      {session ? (
        <>
          <span className="relative flex h-2.5 w-2.5"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" /><span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" /></span>
          {overdue ? <AlertTriangle className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
          <span className="font-medium tabular-nums" data-testid="recording-elapsed">{mmss(elapsed)}</span>
          <span className="hidden sm:inline opacity-90 max-w-[180px] truncate">· {overdue ? "Séance longue : pensez à arrêter" : session.label}</span>
          {!onSessionPage && <Button size="sm" variant="secondary" className="h-7 rounded-full px-2.5 gap-1 text-xs" onClick={() => navigate(target)} data-testid="recording-goto-btn"><ExternalLink className="w-3.5 h-3.5" /> Séance</Button>}
          <Button size="sm" variant="secondary" className="h-7 rounded-full px-3 gap-1 text-xs" onClick={stop} data-testid="recording-stop-btn"><Square className="w-3.5 h-3.5" /> Arrêter</Button>
        </>
      ) : (
        <><Loader2 className="w-4 h-4 animate-spin" /><span>Transcription en cours…</span></>
      )}
    </div>
  );
};

export default RecordingWidget;
